import styled from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: calc(100vh + -120px);
    padding-block: 60px;
    margin-inline: auto;

    @media only screen and (min-width: 500px) {
        width: 530px;
    }
`